import { render, staticRenderFns } from "./NewRelease.vue?vue&type=template&id=091c94e4&scoped=true"
import script from "./NewRelease.vue?vue&type=script&lang=js"
export * from "./NewRelease.vue?vue&type=script&lang=js"
import style0 from "./NewRelease.vue?vue&type=style&index=0&id=091c94e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091c94e4",
  null
  
)

export default component.exports